import React, { useEffect, useState } from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
  TextField, Container, Grid, Button
} from '@mui/material';
import { styled } from '@mui/system';
import axios from 'axios';
import dayjs from 'dayjs'; // For date formatting
import { useNavigate } from 'react-router-dom';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:hover': {
    backgroundColor: '#f0f0f0',
  },
}));

function DailyDealerSummary() {
  const [stock, setStock] = useState([]);
  const [filteredStock, setFilteredStock] = useState([]); // Show all stock initially
  const [fromDate, setFromDate] = useState(dayjs().format('YYYY-MM-DD')); // Default to today
  const [toDate, setToDate] = useState(dayjs().format('YYYY-MM-DD')); // Default to today
  const [searchQuery, setSearchQuery] = useState("");

  const [totalInAmount,setTotalInamount] = useState(0)
  const [totalOutAmount,setTotalOutAmount] = useState(0)

  const [inQty,setInqty] = useState(0)
  const [outQty,setOutQty] = useState(0)

  useEffect(() => {
    const fetchStockData = async () => {
      try {
        const res = await axios.get("https://servermunidasa.ccsoftwares.com/stock/gelAllTicketStocksforDealer");
        //console.log(res.data);
        setStock(res.data);
        setFilteredStock(res.data); // Initialize filtered stock with all stock data
      } catch (error) {
        console.error('Error fetching stock data:', error);
      }
    };
    fetchStockData();
  }, []);



  useEffect(() => {
    filterData();
  }, [fromDate, toDate, searchQuery, stock]);

  // Filtering logic
  const filterData = () => {
    const filtered = stock.filter((row) => {
      const rowDrawDate = new Date(row.drawDate).toISOString().split('T')[0];
      const matchesDate = rowDrawDate >= fromDate && rowDrawDate <= toDate;
      const matchesSearch = row.lottery.toLowerCase().includes(searchQuery.toLowerCase());
      return matchesDate && matchesSearch;
    });

    //console.log(filtered)

    var inTotal = 0.00;
    var outTotal = 0.00;

    var inQty = 0;
    var outQty = 0;


    filtered.map((e,i) =>{
        //console.log(e)
        inTotal += parseFloat(e.totalIn);
        outTotal += parseFloat(e.totalOut);
        inQty += parseInt(e.totalInQty);
        outQty += parseInt(e.totalOutQty)
    })

    setTotalInamount(inTotal)
    setTotalOutAmount(outTotal)
    setInqty(inQty)
    setOutQty(outQty)

    setFilteredStock(filtered);
  };

  const handleClearFilters = () => {
    setFromDate(dayjs().format('YYYY-MM-DD')); // Reset to today
    setToDate(dayjs().format('YYYY-MM-DD')); // Reset to today
    setSearchQuery(''); // Clear search query
    setFilteredStock(stock); // Reset filtered stock to all stock data
  };

  const navigate = useNavigate();

  const generatePDF = () => {
    const pdf = new jsPDF();
  
    // Set the agency name centered in bold
    pdf.setFontSize(16);
    pdf.setFont("helvetica", "bold");
    pdf.text("M.M.Munidasa Lottery Agency", pdf.internal.pageSize.getWidth() / 2, 25, { align: 'center' });
  
    // Set the address centered in a smaller font
    pdf.setFontSize(12);
    pdf.setFont("helvetica", "normal");
    const addressLines = [
      "175/23/E, Mahawatta Road,",
      "Pelanwatta, Pannipitiya",
      "Tel. (+94) 788 393 515"
    ];
  
    addressLines.forEach((line, index) => {
      pdf.text(line, pdf.internal.pageSize.getWidth() / 2, 30 + (index * 5), { align: 'center' });
    });

    const lineY = 50; 
    pdf.setLineWidth(0.5); 
    pdf.line(10, lineY, pdf.internal.pageSize.getWidth() - 10, lineY); // Draw the line from left to right
  
    const todayDate = dayjs().format('YYYY-MM-DD');
    pdf.setFontSize(12);
    pdf.text(`Date: ${todayDate}`, 10, 45); 

    const pdfTable = filteredStock.map((row) => [
      row.lottery,
      row.drawDate.split('T')[0],
      row.currentStock,
      row.remainingStock,
      row.currentStock - row.remainingStock,
      row.totalIn,
      row.totalOut
    ]);
  
    pdf.setFontSize(12); 
    const columnCount = 7; // Total number of columns
    const columnWidth = (pdf.internal.pageSize.getWidth() - 20) / columnCount; // Calculate equal width

    pdf.autoTable({
      head: [['Lottery', 'Draw Date', 'Initial Stock', 'Remaining Stock', 'Sold Stock', 'Ticket Purchase', 'Ticket Sold']],
      body: pdfTable,
      startY: 55,
      styles: { 
        overflow: 'linebreak',
        cellPadding: 3,
        fontSize: 10,
        fillColor: [255, 255, 255], 
        textColor: [0, 0, 0], 
      },
      headStyles: {
        fillColor: [255, 255, 255], 
        textColor: [0, 0, 0], 
      },
      theme: 'grid',
      columnStyles: {
        0: { cellWidth: columnWidth },
        1: { cellWidth: columnWidth },
        2: { cellWidth: columnWidth },
        3: { cellWidth: columnWidth },
        4: { cellWidth: columnWidth },
        5: { cellWidth: columnWidth },
        6: { cellWidth: columnWidth }
      }
    });

    pdf.setFontSize(12);
    pdf.text(`Total Ticket Purchase Amount: Rs. ${parseFloat(totalInAmount).toFixed(2)}`, 10, pdf.autoTable.previous.finalY + 10);
    pdf.text(`Total Sold Amount: Rs. ${parseFloat(totalOutAmount).toFixed(2)}`, 10, pdf.autoTable.previous.finalY + 15);
  
    pdf.text(`Total Ticket Purchase quantity: ${inQty}`, 10, pdf.autoTable.previous.finalY + 25);
    pdf.text(`Total Ticket Sold quantity: ${outQty}`, 10, pdf.autoTable.previous.finalY + 30);
  
    pdf.setFontSize(10); // Set font size for footer
    pdf.text("CC Softwares @ 2024", pdf.internal.pageSize.getWidth() / 2, pdf.autoTable.previous.finalY + 55, { align: 'center' });
  
    // Save the PDF
    pdf.save('stock_report.pdf');
};

  useEffect(() => {

    filterData();

   
  }, [fromDate, toDate, searchQuery, stock]);
  
  // Calculate total purchase and sold amounts based on filtered stock

  return (
    <>
      <Grid xs={12} md={12}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'left', height: 40 ,marginTop : 20}}>
          <button
            style={{
                backgroundColor: '#E7EDFA',
                color: 'Black',
                border: 'none',
                cursor: 'pointer',
                fontSize: 30,
                marginTop: 10
            }}
            onClick={() => navigate(-1)}
          >
            <ArrowCircleLeftIcon fontSize='2' />
          </button>
          <div style={{ fontFamily: 'Segoe UI', fontSize: 28, fontWeight: '400' }}>
            Ticket Stock
          </div>
        </div>
      </Grid>
      <Paper elevation={3} style={{ padding: '20px', marginTop: '20px' }}>
        <Grid container spacing={2}> 
          <Grid item md={6} xs={12}>
            <TextField
              fullWidth
              label="From Date"
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
              sx={{ marginBottom: '20px' }}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <TextField
              fullWidth
              label="To Date"
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
              sx={{ marginBottom: '20px' }}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <TextField
              fullWidth
              label="Search Lottery"
              variant="outlined"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <Button 
              variant="contained" 
              color="primary" 
              onClick={handleClearFilters}
            >
              Clear Filters
            </Button>
          </Grid>
        </Grid>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Lottery</TableCell>
                <TableCell>Draw Date</TableCell>
                <TableCell>Current Stock</TableCell>
                <TableCell>Remaining Stock</TableCell>
                <TableCell>Sold Stock</TableCell>
                <TableCell>Total Purchase</TableCell>
                <TableCell>Total Sold</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredStock.map((row) => (
                <StyledTableRow key={row.id}>
                  <TableCell>{row.lottery}</TableCell>
                  <TableCell>{new Date(row.drawDate).toLocaleDateString("en-US", { timeZone: "Asia/Colombo" })}</TableCell>
                  <TableCell>{row.currentStock}</TableCell>
                  <TableCell>{row.remainingStock}</TableCell>
                  <TableCell>{row.currentStock - row.remainingStock}</TableCell>
                  <TableCell>{row.totalIn}</TableCell>
                  <TableCell>{row.totalOut}</TableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between' }}>
          <Button variant="contained" onClick={generatePDF}>
            Download PDF
          </Button>
          <div>
            <span>Total Ticket Purchase Amount: Rs. {parseFloat(totalInAmount).toFixed(2)}</span><br />
            <span>Total Sold Amount: Rs. {parseFloat(totalOutAmount).toFixed(2)}</span>
          </div>
        </div>
      </Paper>
    </>
  );
}

export default DailyDealerSummary;
